// extracted by mini-css-extract-plugin
export default {"addButton":"styles_addButton__lgIXG","container":"styles_container__QxpON","labels":"styles_labels__tmxVH"};